import React, { useContext } from "react";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/apl/apl";
import "codemirror/mode/asn.1/asn.1";
import "codemirror/mode/asterisk/asterisk";
import "codemirror/mode/brainfuck/brainfuck";
import "codemirror/mode/clojure/clojure";
import "codemirror/mode/cmake/cmake";
import "codemirror/mode/clike/clike";
import "codemirror/mode/cobol/cobol";
import "codemirror/mode/coffeescript/coffeescript";
import "codemirror/mode/crystal/crystal";
import "codemirror/mode/css/css";
import "codemirror/mode/cypher/cypher";
import "codemirror/mode/d/d";
import "codemirror/mode/dart/dart";
import "codemirror/mode/django/django";
import "codemirror/mode/dockerfile/dockerfile";
import "codemirror/mode/diff/diff";
import "codemirror/mode/dtd/dtd";
import "codemirror/mode/dylan/dylan";
import "codemirror/mode/ebnf/ebnf";
import "codemirror/mode/ecl/ecl";
import "codemirror/mode/eiffel/eiffel";
import "codemirror/mode/elm/elm";
import "codemirror/mode/erlang/erlang";
import "codemirror/mode/factor/factor";
import "codemirror/mode/fcl/fcl";
import "codemirror/mode/forth/forth";
import "codemirror/mode/fortran/fortran";
import "codemirror/mode/gas/gas";
import "codemirror/mode/gherkin/gherkin";
import "codemirror/mode/go/go";
import "codemirror/mode/groovy/groovy";
import "codemirror/mode/haml/haml";
import "codemirror/mode/handlebars/handlebars";
import "codemirror/mode/haskell/haskell";
import "codemirror/mode/haxe/haxe";
import "codemirror/mode/http/http";
import "codemirror/mode/idl/idl";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/jinja2/jinja2";
import "codemirror/mode/julia/julia";
import "codemirror/mode/livescript/livescript";
import "codemirror/mode/lua/lua";
import "codemirror/mode/markdown/markdown";
import "codemirror/mode/mathematica/mathematica";
import "codemirror/mode/mbox/mbox";
import "codemirror/mode/mirc/mirc";
import "codemirror/mode/modelica/modelica";
import "codemirror/mode/mscgen/mscgen";
import "codemirror/mode/mumps/mumps";
import "codemirror/mode/nginx/nginx";
import "codemirror/mode/nsis/nsis";
import "codemirror/mode/ntriples/ntriples";
import "codemirror/mode/octave/octave";
import "codemirror/mode/oz/oz";
import "codemirror/mode/pascal/pascal";
import "codemirror/mode/pegjs/pegjs";
import "codemirror/mode/perl/perl";
import "codemirror/mode/php/php";
import "codemirror/mode/pig/pig";
import "codemirror/mode/powershell/powershell";
import "codemirror/mode/properties/properties";
import "codemirror/mode/protobuf/protobuf";
import "codemirror/mode/pug/pug";
import "codemirror/mode/puppet/puppet";
import "codemirror/mode/python/python";
import "codemirror/mode/q/q";
import "codemirror/mode/r/r";
import "codemirror/mode/rpm/rpm";
import "codemirror/mode/ruby/ruby";
import "codemirror/mode/rust/rust";
import "codemirror/mode/sas/sas";
import "codemirror/mode/sass/sass";
import "codemirror/mode/scheme/scheme";
import "codemirror/mode/shell/shell";
import "codemirror/mode/sieve/sieve";
import "codemirror/mode/slim/slim";
import "codemirror/mode/smalltalk/smalltalk";
import "codemirror/mode/smarty/smarty";
import "codemirror/mode/solr/solr";
import "codemirror/mode/soy/soy";
import "codemirror/mode/sql/sql";
import "codemirror/mode/swift/swift";
import "codemirror/mode/stex/stex";
import "codemirror/mode/tcl/tcl";
import "codemirror/mode/textile/textile";
import "codemirror/mode/tiddlywiki/tiddlywiki";
import "codemirror/mode/tiki/tiki";
import "codemirror/mode/toml/toml";
import "codemirror/mode/tornado/tornado";
import "codemirror/mode/troff/troff";
import "codemirror/mode/ttcn/ttcn";
import "codemirror/mode/turtle/turtle";
import "codemirror/mode/twig/twig";
import "codemirror/mode/vbscript/vbscript";
import "codemirror/mode/velocity/velocity";
import "codemirror/mode/verilog/verilog";
import "codemirror/mode/vhdl/vhdl";
import "codemirror/mode/vue/vue";
import "codemirror/mode/webidl/webidl";
import "codemirror/mode/xml/xml";
import "codemirror/mode/xquery/xquery";
import "codemirror/mode/yacas/yacas";
import "codemirror/mode/yaml/yaml";
import "codemirror/mode/z80/z80";
import { Controlled as CodeMirror } from "react-codemirror2";
import { Context } from "../../context/Context";
import { getValue, handleChange } from "../../utils/update.utils";
import { formatLangText, formatText } from "../../utils/text.utils";
import "../../CodeThemes/Abbott.css";
import "../../CodeThemes/Ayu-Dark.css";
import "../../CodeThemes/Ayu-Mirage.css";
import "../../CodeThemes/Base16-Dark.css";
import "../../CodeThemes/Base16-Light.css";
import "../../CodeThemes/Dracula.css";
import "../../CodeThemes/Duotone.css";
import "../../CodeThemes/Material.css";
import "../../CodeThemes/Midnight.css";
import "../../CodeThemes/Monokai.css";
import "../../CodeThemes/Mreq.css";
import "../../CodeThemes/Nord.css";
import "../../CodeThemes/One-Dark.css";
import "../../CodeThemes/One-Light.css";
import "../../CodeThemes/Tomorrow-Night-Eighties.css";
import "../../CodeThemes/Venom.css";
import "../../CodeThemes/Github-Dark.css";
import "../../CodeThemes/Github-Light.css";
import { closeMenu } from "../../helper/menu";

export default function Code() {
  const {
    state,
    setState,
    codeRef,
    menus,
    setMenus,
    setIsOpen,
    code,
    setCode,
  } = useContext(Context);

  return (
    <CodeMirror
      className={`codemirror-wrapper  ${
        getValue(state, ["editor", "font", "type"]).value
      } text-${
        getValue(state, ["editor", "font", "size"]).value
      } leading-${getValue(state, [
        "editor",
        "lineHeight",
      ]).value.toLowerCase()} ${formatText(
        getValue(state, ["editor", "font", "family"]).value
      )}`}
      value={code}
      options={{
        lineWrapping: true,
        lint: true,
        mode: formatLangText(getValue(state, ["theme", "codeLang"]).value),
        theme: formatText(
          getValue(state, ["theme", "codeTheme"]).value.toLowerCase()
        ),
        lineNumbers: state.editor.lineNumber,
        scrollbarStyle: null,
      }}
      onBeforeChange={(editor, data, value) => {
        if (getValue(menus, null, true)?.txt === "Export") {
          closeMenu(menus, setMenus, setIsOpen);
        }
        codeRef.current.style.height = "auto";
        let tempCode = code;
        tempCode = value;
        setCode(tempCode);
      }}
    />
  );
}
